import React from 'react';
import FormReplyComment from './FormReplyComment';
import Helper from './Helper';

class ProductCommentChild extends React.Component {
    
    constructor(props)
    {
        super(props);
        this.state = {
            isShowFormReply:false,
        }
    }
    handleShowReply=(isShowFormReply)=>{
        this.setState({
            isShowFormReply:isShowFormReply
        })
    }
    render(){
        let {review, account, product, topReview} = this.props,
        {isShowFormReply} = this.state;
        return (
            <li className="row">
                <div className="col-sm-2 col-12 review-content__name text-center">
                    <img src={Helper.getSiteUrl() + "/resource/images/avatar_men.png"} className="img-fluid d-block mx-auto" style={{width:'85px'}}/>
                    <span className="text-name">{review.name}</span>
                </div>
                <div className="col-sm-10 col-12 review-content__detail mt-2">
                    <p className="p-0 m-0 review-content__detail__title">{review.title}</p>
                    <p className="pb-1 m-0 review-content__detail__small">{review.time}</p>
                    <div className="review-content__detail__text">
                        {review.des}
                        {review.id &&
                        <p className="review-block-action mb-2">
                            <button className="mr-3" onClick={()=>this.handleShowReply(true)}><i className="fas fa-reply" /> Trả lời</button>
                            {isShowFormReply ? 
                            <button onClick={()=>this.handleShowReply(false)}><i className="fas fa-times" /> Đóng</button>
                            :null} 
                        </p>
                        }
                    </div>
                </div>
                <div className="col-12">
                        {isShowFormReply &&
                        <FormReplyComment review={review} 
                        handleShowReply={this.handleShowReply} 
                        product={product} account={account} replyTo={topReview.id} />
                        }
                </div>
            </li>
        )
    }
}
export default ProductCommentChild;